import script from "./toolTip.vue?vue&type=script&setup=true&lang=js"
export * from "./toolTip.vue?vue&type=script&setup=true&lang=js"

import "./toolTip.vue?vue&type=style&index=0&id=09190ac0&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09190ac0"]])

export default __exports__